import { useQuery } from 'react-query';
import { camelize } from '../camelize';

const getVisionplannerDetails = () => fetch('api/vpcaccess/get-visionplanner-details').then(response => response.json()).then(camelize);

export const useVisionplannerDetails = () => useQuery('visionplannerDetails', getVisionplannerDetails, { refetchOnWindowFocus: false });
